'use strict';

var $    = require('jquery');
var _    = require('underscore');
var Core = require('../core/core.js');

/**
 * Creates an inspector with value and unit
 *
 * @class
 */

class InspectorSliderAdvanced extends Core {

	_defaults() {
		return {
			target: '.js-editor',
			fields: {
				'title': '',
				'value': '',
                'min': 1,
                'max': 100,
				'steps': undefined,
                'ticks': undefined,
                'showtext': true,
                'orientation': 'horizontal',
                'displayUnit' : undefined
			}
		};
	}

	constructor(options) {
		super(options);

		this.template = `
        <div class="editor__inspector__item">
          <div class="editor__inspector__item__label"><%- title %></div>
          <div class="editor__inspector__item__ui-slider editor__inspector__item__ui-slider-<%- orientation %>">
          <div class="editor__inspector__item__ui-slider-area <% if (showtext) { %> editor__inspector__item__ui-slider-area-has-text <% } %>">
            <a class="editor__inspector__item__ui-slider-handle"><div class="editor__inspector__item__ui-slider-icon"></div></a>
            <div class="editor__inspector__item__ui-slider-background"></div>
            <div class="editor__inspector__item__ui-slider-padding"></div>
          </div>
          <% if (showtext) { %> <div class="editor__inspector__item__ui-slider-text"></div>
          <input class="editor__inspector__item__ui-slider-input" type="text"<% } %>
        </div>
        </div>
		`;

		super.render();

        var sliderhandle = $(this.$el).find('.editor__inspector__item__ui-slider-handle');
        var sliderhandleicon = $(this.$el).find('.editor__inspector__item__ui-slider-icon');

        var sliderarea = $(this.$el).find('.editor__inspector__item__ui-slider-area');
        var sliderbackground = $(this.$el).find('.editor__inspector__item__ui-slider-background');

        var slidertextlabel = $(this.$el).find('.editor__inspector__item__ui-slider-text');
        var slidertextinput = $(this.$el).find('.editor__inspector__item__ui-slider-input');

        var params = options.fields;

        var min = params.min || 0;
        var max = params.max || 1;

        var upperlimit = max-min;

        var steps = params.steps;
        var steparray;
        var ticks = params.ticks;

        var showtext = params.showtext;
        var displayUnit = params.displayUnit ? true : false;
        var unit = params.displayUnit || 'mm';

        this.isVertical = params.orientation === 'vertical' ? true : false;

        var me=this;

        this._value = params.value || min;

        var _onInputFocusOut = function () {
            slidertextinput.hide();
            slidertextlabel.show();
        };

        var _onInputTextKeyDown = function (e) {
            if(e.originalEvent.keyCode === 13 || e.originalEvent.keyCode === 27) {
                var value = displayUnittoInternalUnit(slidertextinput.val());
                setSliderPosition(valueToAbsPosition(value));
                _onInputFocusOut();
            }
        };


        if(slidertextinput && slidertextinput.size()) {
            slidertextinput.bind('keydown', _onInputTextKeyDown);
            slidertextinput.bind('focusout', _onInputFocusOut);
        }

        slidertextlabel.bind('click', function () {
            if(slidertextinput) {
                displayText(me._value);
                slidertextlabel.hide();
                slidertextinput.show();
                slidertextinput.select();
                slidertextinput.focus();
            }
        });

        /**
        Get or set the value of the slider.
        @property {String} value
        @public
        **/
        Object.defineProperty(this, "value",{
            get : function () {
                return Number(me._value.toFixed(12));
            },
            set : function (value) {
                removeTransitionEffect();
                setSliderPosition(valueToAbsPosition(value));
                setTimeout(function () {
                    addTransitionEffect();
                }, 500);

            },
            enumerable : true
        });

        var left, startPosition, dragging;

        if(steps !== undefined) {
            if(steps instanceof Array) {
                steparray = steps;
                if(steparray.indexOf(min) < 0 ){
                    steparray.unshift(min);
                }
                if(steparray.indexOf(max) < 0) {
                    steparray.push(max);
                }
            } else {
                steparray = [min];
                var step = min;
                do {
                    step = step + steps;
                    steparray.push(step);
                } while(step < max);
            }
        }

        var displayUnittoInternalUnit = function (value) {
                switch(unit) {
                    case 'ft':
                        value = value * 304.8;
                    break;
                    case 'in':
                        value = value * 25.4;
                    break;
                    case 'm':
                        value = value * 1000;
                    break;
                    case 'cm':
                        value = value * 10;
                    break;
                }
            return value;
        };

        var addTransitionEffect = function () {
            removeTransitionEffect();
            var handleCSSString = "left 0.5s ease-in-out";
            var backgroundCSSString = "width 0.5s ease-in-out";
            if(me.isVertical) {
                handleCSSString = "top 0.5s ease-in-out";
                backgroundCSSString = "height 0.5s ease-in-out";
            }
             sliderhandle.css({
                "transition": handleCSSString,
                "-webkit-transition": handleCSSString,
                "-moz-transition": handleCSSString,
                "-o-transition": handleCSSString,
            });
            sliderbackground.css({
                "transition": backgroundCSSString,
                "-webkit-transition": backgroundCSSString,
                "-moz-transition": backgroundCSSString,
                "-o-transition": backgroundCSSString,
           });
        };

        var removeTransitionEffect = function () {
            sliderhandle.css({
                "transition": "",
                "-webkit-transition": "",
                "-moz-transition": "",
                "-o-transition": "",
            });
            sliderbackground.css({
                "transition": "",
                "-webkit-transition": "",
                "-moz-transition": "",
                "-o-transition": "",
            });
        };

        var valueToAbsPosition = function (value) {
            var maximum = sliderarea.width();
            if(me.isVertical) {
                maximum = sliderarea.height();
                maximum = maximum > 0 ? maximum : 10;
                return (((((max + min) - value) - min) * maximum) / upperlimit);
            }
            else
            {
                maximum = maximum > 0 ? maximum : 10;
                return ((value - min) * maximum) / upperlimit;
            }
        };

        var absPositionToPercentage = function (absposition) {
            var maximum = sliderarea.width();
            if(me.isVertical) {
                maximum = sliderarea.height();
            }
            maximum = maximum > 0 ? maximum : 10;
            return (absposition / maximum) * 100;
        };

        var nearestStepValue = function (value) {
            if(!steparray || steparray.length === 0) return value;
            var stepcount = steparray.length;
            var closest;
            var smallestdiff;
            for(var i=0;i<stepcount;i++) {
                var step = steparray[i];
                var diff = Math.abs(step-value);
                if(smallestdiff === undefined || diff <= smallestdiff) {
                    smallestdiff = diff;
                    closest = step;
                }
            }
            return closest;
        };

        var displayText = function (value) {
            if(showtext) {
                switch(unit) {
                    case 'ft':
                        value = value / 304.8;
                    break;
                    case 'in':
                        value = value / 25.4;
                    break;
                    case 'm':
                        value = value / 1000;
                    break;
                    case 'cm':
                        value = value / 10;
                    break;
                }
                var val = Number(value.toFixed(2));
                var text;
                if(displayUnit) {
                    text = val + ' ' + unit;
                }
                else {
                    text = val;
                }
                slidertextlabel.text(text);

                if(slidertextinput) {
                    slidertextinput.val(val);
                }
            }
        };

        var addTicks = function () {
            var tickcount = ticks.length;

            var prev = 0;
            for (var i = 0; i < tickcount; i++) {
                var current = absPositionToPercentage(valueToAbsPosition(ticks[i]));
                var difference = current - prev;
                var stepdiv;
                if(me.isVertical) {
                    stepdiv = $('<div class="editor__inspector__item__ui-slider-step" />').css({
                        'top':current + '%'
                    });
                } else {
                    stepdiv = $('<div class="editor__inspector__item__ui-slider-step" />').css({
                        'width': difference + '%',
                        'left': prev + '%'
                    });
                }

                sliderarea.append(stepdiv);
                prev = prev + difference;
            }
        };
        if(ticks) addTicks();

        var setSliderPosition = function (position) {
            var maximum = sliderarea.width();
            if(me.isVertical) {
                maximum = sliderarea.height();
            }
            maximum = maximum > 0 ? maximum : 10;
            if(position < 0) position = 0;
            if(position > maximum) position = maximum;


            var val, percentageVal, nearestval;

            if(me.isVertical) {
                val = (max + min) - (min + (position/maximum) * upperlimit);
                nearestval = nearestStepValue(val);
                me._value = nearestval;

               // val = min + (position/maximum) * upperlimit;


                percentageVal = absPositionToPercentage(valueToAbsPosition(nearestval));
                sliderhandle.css('top', percentageVal + '%');
                sliderbackground.css("height" , (100 - percentageVal) + '%');
            } else {
                val = min + (position/maximum) * upperlimit;
                nearestval = nearestStepValue(val);
                me._value = nearestval;
                percentageVal = absPositionToPercentage(valueToAbsPosition(nearestval));
                sliderhandle.css('left', percentageVal + '%');
                sliderbackground.css("width" , percentageVal + '%');
            }

            displayText(nearestval);
        };

        var mouseMove = function (event) {
            if(dragging !== true) { return; }

            removeTransitionEffect();
            event.preventDefault();
            var delta;
            if(me.isVertical) {
                delta = event.clientY - startPosition;
            } else {
                delta = event.clientX - startPosition;
            }

            setSliderPosition(delta);

            $(me.$el).trigger('Cioui:Inspector:value', me.value.toString());
        };

        var mouseUp = function (event) {
            if(dragging === true) {
                dragging = false;
                event.preventDefault();
                document.removeEventListener('mousemove', mouseMove);
                document.removeEventListener('mouseup', mouseUp);

                $(me.$el).trigger('Cioui:Inspector:blur', me.value.toString());
                addTransitionEffect();
            }
        };

        sliderhandle[0].addEventListener("mousedown", function(ev) {
            ev = ev || window.event;

            var startMargin;
            if(me.isVertical) {
                startMargin = sliderhandle.outerHeight(true) - sliderhandle.outerHeight(false);
                startPosition = ev.clientY - this.offsetTop + startMargin;
            } else {
                startMargin = sliderhandle.outerWidth(true) - sliderhandle.outerWidth(false);
                startPosition = ev.clientX - this.offsetLeft + startMargin;
            }

            dragging = true;

            document.addEventListener('mousemove', mouseMove);
            document.addEventListener('mouseup', mouseUp);

            $(me.$el).trigger('Cioui:Inspector:focus', me.value.toString());

        });

        sliderarea[0].addEventListener("click", function (event) {
            var delta;
            if(me.isVertical) {
                delta = event.offsetY===undefined?event.layerY:event.offsetY;
                if($(event.target).hasClass('editor__inspector__item__ui-slider-step') || $(event.target).hasClass('editor__inspector__item__ui-slider-background')) {
                    delta = delta + $(event.target).position().top;
                }
            }
            else {
                delta = event.offsetX===undefined?event.layerX:event.offsetX;
                if($(event.target).hasClass('editor__inspector__item__ui-slider-step')) {
                    delta = delta + $(event.target).position().left;
                }
            }

            if(event.target === sliderhandle[0] || event.target === sliderhandleicon[0]) {
                return;
            }

            $(me.$el).trigger('Cioui:Inspector:focus', me.value.toString());
            setSliderPosition(delta);
        });

        addTransitionEffect();
        me.value = this._value;
        displayText(this._value);

        sliderhandle.bind('transitionend webkitTransitionEnd oTransitionEnd otransitionend MSTransitionEnd', function() {
            $(me.$el).trigger('Cioui:Inspector:value', me.value.toString());
            $(me.$el).trigger('Cioui:Inspector:blur', me.value.toString());
        });


      }

}
module.exports = InspectorSliderAdvanced;
